import React, { useEffect, useState } from "react";
import { Contact_Type, Message_Type } from "../model";
import { collection, doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import Loading from "../components/Loading";
import { setMessageData } from "../firebase/functions/message";

const ContactPage = () => {
  const [contact, setContact] = useState<Contact_Type>();
  const [loading, setLoading] = useState<boolean>(false);

  // messages states
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [message, setMessage] = useState<string>("");

  // sendig messages
  const [sendingMessages, setSendingMessages] = useState<Message_Type[]>([]);

  useEffect(() => {
    setLoading(true);
    onSnapshot(
      doc(collection(db, "contact"), "contact"),
      (snapshot) => {
        setContact(snapshot.data() as Contact_Type);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  }, []);

  useEffect(() => {
    setLoading(true);
    setSendingMessages([]);
    onSnapshot(collection(db, "messages"), (snapshot) => {
      const data: Message_Type[] = snapshot.docs.map(
        (doc) => doc.data() as Message_Type
      );
      setSendingMessages(data);
      setLoading(false);
    });
  }, []);

  const handleSendMessage = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!name.length || !email.length || !message.length) return;

    const newMessage: Message_Type = {
      id: (Math.random() + 1).toString(36).substring(7),
      name: name,
      email: email,
      message: message,
    };

    setMessageData(newMessage).then(() => {
      setName("");
      setEmail("");
      setMessage("");
      alert("Message Sent");
    });
  };

  return (
    <div className="bg-gray-100 py-16">
      {(!contact || loading) && <Loading />}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Contact Information
          </h2>
        </div>
        <div className="mt-12">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {/* Contact Information */}
            {contact && (
              <>
                <div className="bg-white overflow-hidden shadow rounded-lg">
                  <div className="px-4 py-5 sm:p-6">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                      Email
                    </h3>
                    <div className="mt-2">
                      <p className="text-sm text-indigo-500 hover:text-indigo-600">
                        <a href={`mailto:${contact.email}`}>{contact.email}</a>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white overflow-hidden shadow rounded-lg">
                  <div className="px-4 py-5 sm:p-6">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                      Phone
                    </h3>
                    <div className="mt-2">
                      <p className="text-sm text-indigo-500 hover:text-indigo-600">
                        <a href={`tel:${contact.phone}`}>{contact.phone}</a>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white overflow-hidden shadow rounded-lg">
                  <div className="px-4 py-5 sm:p-6">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                      Social Media
                    </h3>
                    <div className="mt-2 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4">
                      {contact.socialAccounts.map((account, index) => (
                        <p key={index} className="text-sm text-gray-500">
                          <a
                            href={account.url}
                            className="text-indigo-500 hover:text-indigo-600 capitalize"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {account.type}
                          </a>
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Contact Form */}
            <div className="bg-white overflow-hidden shadow rounded-lg col-span-2">
              <div className="px-4 py-5 sm:p-6">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                  Contact Form{" "}
                  {sendingMessages.length > 10 && (
                    <sup className="text-gray-500">
                      so far, {sendingMessages.length} and more messages was
                      sent.
                    </sup>
                  )}
                </h3>
                <form className="mt-4" onSubmit={handleSendMessage}>
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Name
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="name"
                        id="name"
                        className="p-2 border shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        placeholder="Your name"
                        onChange={(e) => setName(e.target.value)}
                        value={name}
                      />
                    </div>
                  </div>
                  <div className="mt-4">
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Email
                    </label>
                    <div className="mt-1">
                      <input
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        className="p-2 border shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        placeholder="you@example.com"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                      />
                    </div>
                  </div>
                  <div className="mt-4">
                    <label
                      htmlFor="message"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Message
                    </label>
                    <div className="mt-1">
                      <textarea
                        id="message"
                        name="message"
                        rows={4}
                        className="p-2 border shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        placeholder="Your message"
                        onChange={(e) => setMessage(e.target.value)}
                        value={message}
                      />
                    </div>
                  </div>
                  <div className="mt-6">
                    <button
                      type="submit"
                      className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
